import React from 'react'
import Switch from '../../../../../components/FormComponents/Switch'
import Timeline from '../../../../../components/Advertiser/CampaignShare/CampaignPageParts/ReportParts/Timeline'

export default function TimelineOverview({ values, setFieldValue, selectedScenario }) {
  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
    <div className="flex justify-between items-center mb-8">
      <p className="font-bold text-xl dark:text-white">Timeline</p>
      <Switch name="timeline_visible" value={values.timeline_visible} onChange={({ target: { checked }}) => setFieldValue('timeline_visible', checked, true)} eyeSwitch />
    </div>
    {values.timeline_visible && (
      <>
        <Timeline selectedScenario={selectedScenario} values={values}/>
      </>
    )}
  </div>
  )
}